import { render, staticRenderFns } from "./PageEge.vue?vue&type=template&id=6b657569&scoped=true"
import script from "./PageEge.vue?vue&type=script&lang=js"
export * from "./PageEge.vue?vue&type=script&lang=js"
import style0 from "./PageEge.vue?vue&type=style&index=0&id=6b657569&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b657569",
  null
  
)

export default component.exports